module.exports = __webpack_public_path__ + "img/graduation-hat-01.44958deb.svg";